import React, { useContext, useState } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { EditUserTypeRel } from 'modules/Rest'
import { DataRoomsContext, MessageContext } from './Contexts'
import AButton from './AButton'
import { PhoneNumberDialog } from './PhoneNumberDialog'
import ActionButtons, { DirectActionButton } from './ActionButtons'
import EditIcon from '@mui/icons-material/Edit'
import { setModes } from 'modules/Utils'
import { useNavigate } from 'react-router'

const useStyles = makeStyles({
  noUsers: {
    fontStyle: 'italic',
    height: 37,
  },
  centerCell: {
    textAlign: 'center'
  },
  marginButton: {
    marginLeft: 6,
  },
  tfaCell: {
    paddingTop: 3,
    paddingBottom: 3,
  },
  linkCell: {
    textAlign: 'center',
    paddingTop: 3,
    paddingBottom: 3,
  },
  btnCell: {
    textAlign: 'right',
    paddingRight: 0,
    '&:last-child': {
      paddingRight: 0,
    },
    paddingTop: 3,
    paddingBottom: 3,
  },
  dialogContent: {
    width: 400,
  },
})

let tempUsers // needs to be 'global' for this component in order for user removal to work when done in quick succession.

export default function UsersTable({ users = [], setUsers, userTypeKey, twoFactor, linkAccess, viewLink }) {
  const { messageDispatch } = useContext(MessageContext)
  const { triggerRefresh } = useContext(DataRoomsContext)
  const navigate = useNavigate()
  const classes = useStyles()

  const [phoneNumber, setPhoneNumber] = useState('')
  const [selectedUser, setSelectedUser] = useState({})
  const [modeRemoveUser, setModeRemoveUser] = useState('')

  const [modePhoneNumberDialog, setModePhoneNumberDialog] = useState('')

  tempUsers = [...users]

  // Replace or just remove from users array depending on 'replace' boolean
  const replaceUser = (user, replace) => {
    if (replace) {
      tempUsers.splice(
        tempUsers.findIndex(u => u.user === user.user),
        1,
        user
      )
    } else {
      tempUsers.splice(
        tempUsers.findIndex(u => u.user === user.user),
        1
      )
    }
    setUsers(tempUsers)
  }

  const removeUser = user => {
    if (user.is_current_user) {
      setSelectedUser(user)
      setModeRemoveUser('editing')
    } else {
      doRemoveUser(user, false)
    }
  }

  const doRemoveUser = async (user, force) => {
    try {
      const { data: { success, info } } = await EditUserTypeRel({ ...user, user_type: userTypeKey, remove: true, force: force })
      if (success) {
        if (user.is_current_user) {
          await setModes(setModeRemoveUser, ['completing', 1500, ''])
          triggerRefresh()
          navigate('/data-rooms/')
        }
        replaceUser(user, false)
      } else {
        throw new Error(info ? info : 'An error occurred')
      }
    } catch (error) {
      messageDispatch({ type: 'warning', payload: error.message })
    }
  }

  return <>
    <TableContainer>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>User</TableCell>
            {twoFactor && <TableCell>Two-factor phone number</TableCell>}
            {linkAccess && <TableCell className={classes.centerCell}>Link</TableCell>}
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.length ? users.map(user => (
            <TableRow key={user.user}>
              <TableCell>{user.user_name}</TableCell>
              {twoFactor && <TableCell className={classes.tfaCell}>
                {user.two_factor_phone_number}
                <AButton
                  startIcon={<EditIcon/>}
                  className={classes.marginButton}
                  onClick={() => {
                    setSelectedUser(user)
                    setPhoneNumber(user.two_factor_phone_number)
                    setModePhoneNumberDialog('editing')
                  }}
                >
                  Edit
                </AButton>
              </TableCell>}
              {linkAccess && <TableCell className={classes.linkCell}>{user.link && <AButton onClick={() => viewLink(user)}>View</AButton>}</TableCell>}
              <TableCell className={classes.btnCell}>
                <DirectActionButton actionTitle='Remove' color='error' action={() => removeUser(user)} />
              </TableCell>
            </TableRow>
          )) : <TableRow><TableCell className={classes.noUsers} colSpan={2 + (twoFactor ? 1 : 0) + (linkAccess ? 1 : 0)}>No users in group</TableCell></TableRow>
          }
        </TableBody>
      </Table>
    </TableContainer>

    <PhoneNumberDialog
      user={selectedUser}
      userTypeKey={userTypeKey}
      phoneNumber={phoneNumber}
      setPhoneNumber={setPhoneNumber}
      mode={modePhoneNumberDialog}
      setMode={setModePhoneNumberDialog}
      callback={replaceUser}
    />

    <Dialog open={!!modeRemoveUser}>
      <DialogTitle>Confirmation request</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="body2">
          Would you like to remove yourself as administrator of the data room?
        </Typography>
        <Typography variant="body2">
          You will lose all access to the data room.
        </Typography>
      </DialogContent>
      <DialogActions>
        <ActionButtons
          mode={modeRemoveUser}
          setMode={setModeRemoveUser}
          action={() => {
            doRemoveUser(selectedUser, true)
          }}
          cancel={(e, setMode) => setMode('')}
          actionTitle="Remove"
          colorAction="error"
          neverShowEdit={true}
        />
      </DialogActions>
    </Dialog>

  </>
}
